module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.lAction === 'view') ? _c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: 0,
    attrs: {
      "href": "#tab-0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tabitems[0] + ' (' + _vm.staff.length + ')') + "\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 1,
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tabitems[1] + ' (' + _vm.shifts.length + ')') + "\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tabitems[2] + ' (' + _vm.roleList.length + ')') + "\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    attrs: {
      "href": "#tab-3"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.tabitems[3]) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 0,
    attrs: {
      "value": "tab-0"
    }
  }, [_c('v-layout', {
    staticClass: "pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.config.IS_BB_VENDOR) ? _c('v-flex', {
    staticClass: "text-xs-center info pa-2 mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "white--text"
  }, [_vm._v("\n                  Sit back and relax, its "), _c('span', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s(_vm.config.FM_VENDOR_NAME))]), _vm._v(" managed community\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "accent--text",
    staticStyle: {
      "font-family": "'Satisfy', cursive",
      "font-size": "200%",
      "font-weight": "normal"
    }
  }, [_vm._v("\n                  We are proud to serve you\n                ")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "placeholder": "Search name, role, etc...",
      "clearable": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.staffHeadSm,
      "items": _vm.staff,
      "title": "Staff List"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-0 ml-1 mr-1",
    attrs: {
      "label": "Vendor filter",
      "items": _vm.staffVendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "clearable": "",
      "chips": "",
      "multiple": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.loadStaffs
    },
    model: {
      value: (_vm.chosenVendor),
      callback: function($$v) {
        _vm.chosenVendor = $$v
      },
      expression: "chosenVendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm3": ""
    }
  }, [_c('v-switch', {
    staticClass: "mt-3 ml-1 mylable",
    attrs: {
      "label": "Show past staffs as well",
      "hide-details": ""
    },
    on: {
      "change": _vm.loadStaffs
    },
    model: {
      value: (_vm.showAll),
      callback: function($$v) {
        _vm.showAll = $$v
      },
      expression: "showAll"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showQRCode(true)
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("qr_code")]), _vm._v("QR Code")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-2",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.staffHeadSm : _vm.staffHead,
      "items": _vm.staff,
      "hide-actions": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.type === 'VS' ? ((props.item.undeployed_on && props.item.undeployed_on < _vm.handy.formatDBDate(new Date())) ? 'grey--text' : 'info--text') : (props.item.undeployed_on ? 'grey--text' : ''),
          on: {
            "click": function($event) {
              return _vm.showStaff(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_emp_id ? props.item.vendor_emp_id : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.staff_mobile))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && props.item.is_smart_attend) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_c('v-icon', {
          attrs: {
            "color": props.item.is_ms_face_synched ? 'success' : 'warning'
          }
        }, [_vm._v("check")]), _c('v-icon', {
          attrs: {
            "color": props.item.is_fc_dev_synched ? 'success' : 'warning'
          }
        }, [_vm._v("check")]), (props.item.is_sitevisit_attendance && _vm.config.IS_BACKOFFICE_COMM) ? _c('v-icon', {
          attrs: {
            "color": props.item.is_sitevisit_dev_synched ? 'success' : 'warning'
          }
        }, [_vm._v("check")]) : _vm._e()], 1) : (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.shift_abbr))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [(props.item.is_billable === 1) ? _c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("close")])], 1) : _vm._e()])]
      }
    }], null, false, 1360428930)
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    attrs: {
      "value": "tab-1"
    }
  }, [_c('v-layout', {
    staticClass: "pa-1"
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "md9": "",
      "offset-sm3": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.shiftHeadSm : _vm.shiftHead,
      "items": _vm.shifts,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdateShift(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.shift_abbr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.end_time))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.shift_hours))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.break_start))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.break_end))]) : _vm._e()])]
      }
    }], null, false, 4154463508)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    attrs: {
      "value": "tab-2"
    }
  }, [_c('v-layout', {
    staticClass: "pa-1"
  }, [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "md9": "",
      "offset-sm3": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.roleHead,
      "items": _vm.roleList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdateRole(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.role_cat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.short_form))])])]
      }
    }], null, false, 3981719174)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    attrs: {
      "value": "tab-3",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "pa-1"
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey lighten-4"
  }, [_c('span', {
    staticClass: "title ml-2"
  }, [_vm._v("Community Information")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.commDetHead,
      "items": _vm.commDet,
      "hide-actions": "",
      "dense": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.comm_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_email ? props.item.contact_email : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone ? props.item.contact_phone : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.address ? props.item.address : '-'))])])]
      }
    }], null, false, 3905077871)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-1"
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 grey lighten-4"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Active MC")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.addMcDet()
      }
    }
  }, [_vm._v("Add New")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.mcHead,
      "items": _vm.mcList.filter(function (rec) { return rec.status === 'Active'; }),
      "hide-actions": "",
      "dense": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.effective_from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.role_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.mc_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.personal_email_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_send_mail))]), _vm._v(" "), _c('td', {
          staticClass: "layout"
        }, [_c('v-btn', {
          staticClass: "mr-0",
          attrs: {
            "icon": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.prepareEditActive(props.item)
            }
          }
        }, [_vm._v("edit")])], 1)], 1)])]
      }
    }], null, false, 3513772515)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pa-1"
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', {
    staticClass: "py-2 grey lighten-4"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("In Active MC")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.mcHead,
      "items": _vm.mcList.filter(function (rec) { return rec.status === 'In Active'; }),
      "hide-actions": "",
      "dense": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.effective_from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.role_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.mc_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.personal_email_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.is_send_mail))]), _vm._v(" "), _c('td', {
          staticClass: "layout"
        }, [_c('v-btn', {
          staticClass: "mr-0",
          attrs: {
            "icon": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.prepareEditInActive(props.item)
            }
          }
        }, [_vm._v("edit")])], 1)], 1)])]
      }
    }], null, false, 2980423268)
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (this.tab !== 'tab-3') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent black--text"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab === 'tab-0' ? _vm.prepareCreate() : _vm.tab === 'tab-1' ? _vm.prepareCreateShift() : _vm.prepareCreateRole()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " Staff\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.config.IS_BB_VENDOR) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'create') ? _c('v-alert', {
    attrs: {
      "outline": "",
      "value": "true",
      "color": "warning"
    }
  }, [_vm._v("\n                    WARNING: Staffs employed by association or other vendor can be created here. "), _c('br'), _c('br'), _vm._v(_vm._s(_vm.config.FM_VENDOR_NAME) + " staffs have to be created by " + _vm._s(_vm.config.FM_VENDOR_NAME) + " HR in BackBone only.\n                  ")]) : (_vm.lStaff.type === 'VS') ? _c('v-alert', {
    attrs: {
      "outline": "",
      "value": "true",
      "color": "warning"
    }
  }, [_vm._v("\n                    WARNING: Only role, shift and deployment dates can be updated here as this staff is employed by " + _vm._s(_vm.config.FM_VENDOR_NAME) + ". "), _c('br'), _c('br'), _vm._v("Please contact " + _vm._s(_vm.config.FM_VENDOR_NAME) + " HR to update any other details.\n                  ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lStaff.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "staff_name", $$v)
      },
      expression: "lStaff.staff_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Role",
      "items": _vm.roleList,
      "item-value": "staff_role_id",
      "item-text": "staff_role",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lStaff.staff_role_id),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "staff_role_id", $$v)
      },
      expression: "lStaff.staff_role_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Shift",
      "items": _vm.shifts,
      "item-value": "shift_id",
      "item-text": "shift_abbr",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lStaff.shift_id),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "shift_id", $$v)
      },
      expression: "lStaff.shift_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Choose vendor",
      "items": _vm.config.IS_BB_VENDOR && _vm.lAction === 'create' ? _vm.allVendors.filter(function (rec) { return rec.vendor_id !== this$1.config.FM_VENDOR_ID; }) : _vm.allVendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "maxlength": "50",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.validateVendor()
      }
    },
    model: {
      value: (_vm.lStaff.vendor),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "vendor", $$v)
      },
      expression: "lStaff.vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "grey lighten-2 mt-2",
    attrs: {
      "icon": "",
      "to": {
        path: '/vendor'
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Job status",
      "items": ['On Job', 'Resigned', 'Terminated'],
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lStaff.staff_status),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "staff_status", $$v)
      },
      expression: "lStaff.staff_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgDepDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lStaff.deployed_on
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lStaff, "deployed_on", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lStaff, "deployed_on", $event)
      }
    },
    model: {
      value: (_vm.dlgDepDt),
      callback: function($$v) {
        _vm.dlgDepDt = $$v
      },
      expression: "dlgDepDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Deployed Dt",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lStaff.deployed_on),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "deployed_on", $$v)
      },
      expression: "lStaff.deployed_on"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lStaff.deployed_on),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "deployed_on", $$v)
      },
      expression: "lStaff.deployed_on"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgDepDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgDepDt.save(_vm.lStaff.deployed_on)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgLastDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lStaff.undeployed_on
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lStaff, "undeployed_on", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lStaff, "undeployed_on", $event)
      }
    },
    model: {
      value: (_vm.dlgLastDt),
      callback: function($$v) {
        _vm.dlgLastDt = $$v
      },
      expression: "dlgLastDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Undeployed Dt",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lStaff.undeployed_on),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "undeployed_on", $$v)
      },
      expression: "lStaff.undeployed_on"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lStaff.undeployed_on),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "undeployed_on", $$v)
      },
      expression: "lStaff.undeployed_on"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgLastDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgLastDt.save(_vm.lStaff.undeployed_on)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), (_vm.lStaff.staff_status === 'Terminated') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reason for termination",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lStaff.term_reason),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "term_reason", $$v)
      },
      expression: "lStaff.term_reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is Billable?",
      "hide-details": "",
      "disabled": _vm.lAction === 'create'
    },
    model: {
      value: (_vm.lStaff.is_billable),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "is_billable", $$v)
      },
      expression: "lStaff.is_billable"
    }
  })], 1), _vm._v(" "), (_vm.config.IS_BACKOFFICE_COMM) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Site Visit Attendance",
      "hide-details": _vm.lStaff.is_smart_attend == 1,
      "hint": "Configure faces to enable this option",
      "persistent-hint": "",
      "disabled": _vm.lAction === 'create' || !_vm.lStaff.is_smart_attend
    },
    model: {
      value: (_vm.lStaff.is_sitevisit_attendance),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "is_sitevisit_attendance", $$v)
      },
      expression: "lStaff.is_sitevisit_attendance"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Contact Information (optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Mobile no.",
      "hide-details": "",
      "rules": [_vm.rules.mobile],
      "maxlength": "15"
    },
    model: {
      value: (_vm.lStaff.staff_mobile),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "staff_mobile", $$v)
      },
      expression: "lStaff.staff_mobile"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Intercom no.",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lStaff.int_extn),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "int_extn", $$v)
      },
      expression: "lStaff.int_extn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Emergency contact",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lStaff.emergency_contact),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "emergency_contact", $$v)
      },
      expression: "lStaff.emergency_contact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Emergency phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lStaff.emergency_phone),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "emergency_phone", $$v)
      },
      expression: "lStaff.emergency_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Other Information (optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Address",
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lStaff.staff_adr),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "staff_adr", $$v)
      },
      expression: "lStaff.staff_adr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "City",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lStaff.city),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "city", $$v)
      },
      expression: "lStaff.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "PIN",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lStaff.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "pin_code", $$v)
      },
      expression: "lStaff.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Blood group",
      "hide-details": "",
      "maxlength": "5"
    },
    model: {
      value: (_vm.lStaff.blood_group),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "blood_group", $$v)
      },
      expression: "lStaff.blood_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.lStaff.type === 'VS',
      "label": "Known health issue",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lStaff.known_health_issue),
      callback: function($$v) {
        _vm.$set(_vm.lStaff, "known_health_issue", $$v)
      },
      expression: "lStaff.known_health_issue"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent black--text",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create-shift' || _vm.lAction === 'update-shift') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChangesShift(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "md6": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction.substring(0, _vm.lAction.indexOf('-')))) + " Shift\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shift Abbreviation",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lShift.shift_abbr),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "shift_abbr", $$v)
      },
      expression: "lShift.shift_abbr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "shiftStart",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lShift.start_time
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lShift, "start_time", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lShift, "start_time", $event)
      }
    },
    model: {
      value: (_vm.dlgShiftStart),
      callback: function($$v) {
        _vm.dlgShiftStart = $$v
      },
      expression: "dlgShiftStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Starts at",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lShift.start_time),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "start_time", $$v)
      },
      expression: "lShift.start_time"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lShift.start_time),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "start_time", $$v)
      },
      expression: "lShift.start_time"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgShiftStart = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.shiftStart.save(_vm.lShift.start_time)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "shiftEnd",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lShift.end_time
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lShift, "end_time", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lShift, "end_time", $event)
      }
    },
    model: {
      value: (_vm.dlgShiftEnd),
      callback: function($$v) {
        _vm.dlgShiftEnd = $$v
      },
      expression: "dlgShiftEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Ends at",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lShift.end_time),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "end_time", $$v)
      },
      expression: "lShift.end_time"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lShift.end_time),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "end_time", $$v)
      },
      expression: "lShift.end_time"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgShiftEnd = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.shiftEnd.save(_vm.lShift.end_time)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shift Hours",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "5"
    },
    model: {
      value: (_vm.lShift.shift_hours),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "shift_hours", $$v)
      },
      expression: "lShift.shift_hours"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "subheader mt-3 primary--text"
  }, [_vm._v("\n                Additional information (optional)\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "breakStart",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lShift.break_start
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lShift, "break_start", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lShift, "break_start", $event)
      }
    },
    model: {
      value: (_vm.dlgBreakStart),
      callback: function($$v) {
        _vm.dlgBreakStart = $$v
      },
      expression: "dlgBreakStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Break from",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lShift.break_start),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "break_start", $$v)
      },
      expression: "lShift.break_start"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lShift.break_start),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "break_start", $$v)
      },
      expression: "lShift.break_start"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgBreakStart = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.breakStart.save(_vm.lShift.break_start)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "breakEnd",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lShift.break_end
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lShift, "break_end", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lShift, "break_end", $event)
      }
    },
    model: {
      value: (_vm.dlgBreakEnd),
      callback: function($$v) {
        _vm.dlgBreakEnd = $$v
      },
      expression: "dlgBreakEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Break till",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lShift.break_end),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "break_end", $$v)
      },
      expression: "lShift.break_end"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lShift.break_end),
      callback: function($$v) {
        _vm.$set(_vm.lShift, "break_end", $$v)
      },
      expression: "lShift.break_end"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgBreakEnd = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.breakEnd.save(_vm.lShift.break_end)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update-shift') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteShift($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create-role' || _vm.lAction === 'update-role') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "rForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChangesRole(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "md6": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction.substring(0, _vm.lAction.indexOf('-')))) + " Staff Role\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "items": ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS'],
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "20"
    },
    model: {
      value: (_vm.lRole.role_cat),
      callback: function($$v) {
        _vm.$set(_vm.lRole, "role_cat", $$v)
      },
      expression: "lRole.role_cat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Role Name",
      "rules": [_vm.rules.required],
      "maxlength": "50",
      "hide-details": ""
    },
    model: {
      value: (_vm.lRole.staff_role),
      callback: function($$v) {
        _vm.$set(_vm.lRole, "staff_role", $$v)
      },
      expression: "lRole.staff_role"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Short Form of Role Name",
      "rules": [_vm.rules.required],
      "maxlength": "8",
      "hide-details": ""
    },
    model: {
      value: (_vm.lRole.short_form),
      callback: function($$v) {
        _vm.$set(_vm.lRole, "short_form", $$v)
      },
      expression: "lRole.short_form"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update-role') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteRole($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.dlgStaff),
      callback: function($$v) {
        _vm.dlgStaff = $$v
      },
      expression: "dlgStaff"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pb-0 pl-2 pr-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.lStaff.staff_name))]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.lStaff.staff_role))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 info white--text subheading"
  }, [_c('v-divider'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lStaff.staff_status) + " "), _c('span', {
    staticClass: "yellow--text"
  }, [_vm._v("(Shift: " + _vm._s(_vm.lStaff.shift_abbr) + ")")])]), _vm._v(" "), _c('div', [_vm._v("[" + _vm._s(_vm.handy.formatDate(_vm.lStaff.deployed_on)) + " - " + _vm._s((_vm.lStaff.undeployed_on ? _vm.handy.formatDate(_vm.lStaff.undeployed_on) : ' till date')) + "]")])], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Mobile")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lStaff.staff_mobile))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(false) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("content_copy")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Emergency contact")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lStaff.emergency_contact))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Emergency phone")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lStaff.emergency_phone))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(false) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("content_copy")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-subheader', {
    staticClass: "primary--text pa-0"
  }, [_vm._v("Smart Attendance")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center subheading"
  }, [(_vm.lStaff.is_smart_attend) ? _c('div', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.lStaff.is_ms_face_synched ? 'success' : 'warning'
    }
  }, [_vm._v("check")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.lStaff.is_fc_dev_synched ? 'success' : 'warning'
    }
  }, [_vm._v("check")]), _vm._v(" "), (_vm.lStaff.is_sitevisit_attendance && _vm.config.IS_BACKOFFICE_COMM) ? _c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.lStaff.is_sitevisit_dev_synched ? 'success' : 'warning'
    }
  }, [_vm._v("check")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                Faces configured\n                "), _c('div', {
    class: 'caption ' + (_vm.lStaff.is_ms_face_synched ? 'success--text' : 'warning--text')
  }, [(_vm.lStaff.is_ms_face_synched) ? _c('span', [_vm._v("In app attendance")]) : _c('span', [_vm._v("Face server not synched yet"), _c('span', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.lStaff.ms_face_synch_err ? (' (' + _vm.lStaff.ms_face_synch_err + ')') : ''))])])]), _vm._v(" "), _c('div', {
    class: 'caption ' + (_vm.lStaff.is_fc_dev_synched ? 'success--text' : 'warning--text')
  }, [(_vm.lStaff.is_fc_dev_synched) ? _c('span', [_vm._v("FaceCheckin attendance")]) : _c('span', [_vm._v(_vm._s('FaceCheckin device of this site not ' + (_vm.isFaceCheckinConfig ? 'synched yet' : 'configured')))])]), _vm._v(" "), (_vm.lStaff.is_sitevisit_attendance && _vm.config.IS_BACKOFFICE_COMM) ? _c('div', {
    class: 'caption ' + (_vm.lStaff.is_sitevisit_dev_synched ? 'success--text' : 'warning--text')
  }, [(_vm.lStaff.is_sitevisit_dev_synched) ? _c('span', [_vm._v("Site visit attendance")]) : _c('span', [_vm._v(_vm._s('Other devices for site visit attendance not synched yet')), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.showUnsyncDev()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)]) : _vm._e()], 1) : _c('div', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "error"
    }
  }, [_vm._v("close")]), _c('br'), _vm._v("\n                Faces not configured yet\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.lStaff.undeployed_on && _vm.lStaff.undeployed_on < _vm.handy.formatDBDate(new Date()),
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prepareFaceConfig(!_vm.lStaff.is_smart_attend)
      }
    }
  }, [_vm._v(_vm._s(Number(_vm.lStaff.is_smart_attend) ? 'View/Update Faces' : 'Configure Now'))]), _vm._v(" "), (_vm.lStaff.is_smart_attend) ? _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showQRCode()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("qr_code")]), _vm._v("QR Code")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('template', {
    slot: "header"
  }, [_c('div', [_vm._v("More...")])]), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("Address")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2 ml-2",
    attrs: {
      "xs11": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.lStaff.staff_adr))]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.lStaff.city ? _vm.lStaff.city : '') + (_vm.lStaff.pin ? ' - ' + _vm.lStaff.pin : '')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('span', {
    staticClass: "primary--text subheader pl-0"
  }, [_vm._v("Other info")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Blood Group")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lStaff.blood_group))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs5": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Health issue")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lStaff.known_health_issue))])])], 1)], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.lStaff.type === 'CS') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteStaff($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prepareUpdate($event)
      }
    }
  }, [_vm._v("Update Staff")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dlgStaff = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "800px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dlgQRCode),
      callback: function($$v) {
        _vm.dlgQRCode = $$v
      },
      expression: "dlgQRCode"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    ref: "qrcode",
    staticClass: "text-xs-center"
  }, [_c('table', _vm._l((_vm.qrStaffList), function(staffRow, i) {
    return _c('tr', {
      key: i
    }, _vm._l((staffRow), function(staff, j) {
      return _c('td', {
        key: j,
        staticStyle: {
          "padding": "25px"
        }
      }, [(staff.is_smart_attend) ? _c('qrcode-vue', {
        attrs: {
          "value": staff.person_id + '',
          "size": "135",
          "level": "H",
          "render-as": "svg"
        }
      }) : _c('div', {
        staticStyle: {
          "text-align": "center",
          "font-size": "125%"
        }
      }, [_vm._v("X")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "85%",
          "padding-top": "10px",
          "text-align": "center"
        }
      }, [_vm._v("\n              " + _vm._s(staff.staff_name.substring(0, 20)) + "\n            ")])], 1)
    }), 0)
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgQRCode = false
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.printQRCode
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("print")]), _vm._v("Print")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px"
    },
    model: {
      value: (_vm.dlgFaceConfig),
      callback: function($$v) {
        _vm.dlgFaceConfig = $$v
      },
      expression: "dlgFaceConfig"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeFaceConfig($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0 pl-2 pr-2 pb-2 text-xs-center"
  }, [(_vm.faceProgress === 'Done') ? _c('v-icon', {
    attrs: {
      "color": "success",
      "large": ""
    }
  }, [_vm._v("check")]) : (_vm.faceProgress.includes('Error')) ? _c('v-icon', {
    staticClass: "error--text",
    attrs: {
      "large": ""
    }
  }, [_vm._v("close")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title mb-2"
  }, [_vm._v(_vm._s(_vm.faceProgress))]), _vm._v(" "), (_vm.lStaff && _vm.lStaff.reg_faces && _vm.lStaff.reg_faces.filter(function (rec) { return rec.face_url; }).length < _vm.requiredFaces) ? _c('div', [_c('v-icon', {
    staticClass: "mt-0 mb-2"
  }, [_vm._v("arrow_downward")]), _vm._v(" "), _c('video', {
    staticStyle: {
      "width": "280px",
      "height": "210px"
    },
    attrs: {
      "id": "cam",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center pb-1 pt-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.capturePhoto
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1)], 1) : _c('div', [_c('v-btn', {
    staticClass: "mt-0 mb-3",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.prepareFaceConfig()
      }
    }
  }, [_vm._v("Reconfigure")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lStaff.reg_faces), function(face, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs4": ""
      }
    }, [_c('v-card', {
      staticClass: "ma-1",
      staticStyle: {
        "width": "90px",
        "height": "90px"
      }
    }, [(face.face_url) ? _c('div', [_c('img', {
      attrs: {
        "src": face.face_url,
        "height": "89px",
        "width": "89px"
      }
    })]) : _c('div', {
      staticClass: "title pa-2"
    }, [_vm._v("\n              " + _vm._s(i + 1) + "\n            ")])])], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showMcDet),
      callback: function($$v) {
        _vm.showMcDet = $$v
      },
      expression: "showMcDet"
    }
  }, [_c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitMcDet(_vm.lMAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-3 title"
  }, [_vm._v("\n        Add Mc Detail\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "black--text pa-2"
  }, [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "effectFrom",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lMc.effective_from
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lMc, "effective_from", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lMc, "effective_from", $event)
      }
    },
    model: {
      value: (_vm.effectFrom),
      callback: function($$v) {
        _vm.effectFrom = $$v
      },
      expression: "effectFrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Effective from date",
      "append-icon": "event",
      "rules": [_vm.rules.required],
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lMc.effective_from),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "effective_from", $$v)
      },
      expression: "lMc.effective_from"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lMc.effective_from),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "effective_from", $$v)
      },
      expression: "lMc.effective_from"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.effectFrom = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.effectFrom.save(_vm.lMc.effective_from)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "effectTo",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lMc.effective_to
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lMc, "effective_to", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lMc, "effective_to", $event)
      }
    },
    model: {
      value: (_vm.effectTo),
      callback: function($$v) {
        _vm.effectTo = $$v
      },
      expression: "effectTo"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Effective to date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lMc.effective_to),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "effective_to", $$v)
      },
      expression: "lMc.effective_to"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.lMc.effective_from
    },
    model: {
      value: (_vm.lMc.effective_to),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "effective_to", $$v)
      },
      expression: "lMc.effective_to"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.effectTo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.effectTo.save(_vm.lMc.effective_to)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.rwaRoleList,
      "label": "Mc designation",
      "item-value": "role_id",
      "item-text": "role_name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lMc.role_pair),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "role_pair", $$v)
      },
      expression: "lMc.role_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "MC name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lMc.mc_name),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "mc_name", $$v)
      },
      expression: "lMc.mc_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Contact phone",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lMc.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "contact_phone", $$v)
      },
      expression: "lMc.contact_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Personal email id",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lMc.personal_email_id),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "personal_email_id", $$v)
      },
      expression: "lMc.personal_email_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Can send mail?",
      "items": ['Yes', 'No'],
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lMc.is_send_mail),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "is_send_mail", $$v)
      },
      expression: "lMc.is_send_mail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": ['Active', 'In Active'],
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lMc.status),
      callback: function($$v) {
        _vm.$set(_vm.lMc, "status", $$v)
      },
      expression: "lMc.status"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showMcDet = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": "",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("submit")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dlgUnsyncDev),
      callback: function($$v) {
        _vm.dlgUnsyncDev = $$v
      },
      expression: "dlgUnsyncDev"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4 title"
  }, [_vm._v("\n      Unsynched communities (" + _vm._s(_vm.unsynchDevList.length) + ")\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.unsynchDevHd,
      "items": _vm.unsynchDevList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.comm_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.dev_list))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgUnsyncDev = false
      }
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-5e80fcf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Staff.vue
// module id = 856
// module chunks = 8